import { useComputedColorScheme, useMantineColorScheme } from "@mantine/core";
import { useTheme } from "next-themes";

export type ColorScheme = "light" | "dark";

const switchTheme = (scheme?: string): ColorScheme => {
  switch (scheme) {
    case "light":
      return "dark";
    case "dark":
      return "light";
    default:
      return "light";
  }
};

export function useToggleColorScheme(scheme: ColorScheme = "light") {
  const computedColorScheme = useComputedColorScheme(scheme);

  const { resolvedTheme, setTheme } = useTheme();
  const { setColorScheme: setMantineColorScheme } = useMantineColorScheme({
    keepTransitions: true,
  });

  const toggleColorScheme = () => {
    setMantineColorScheme(switchTheme(computedColorScheme));
    setTheme(switchTheme(resolvedTheme));
  };

  const setColorScheme = (colorScheme: ColorScheme) => {
    setMantineColorScheme(colorScheme);
    setTheme(colorScheme);
  };

  const colorScheme = resolvedTheme ?? computedColorScheme;

  return {
    colorScheme,
    toggleColorScheme,
    setColorScheme,
  };
}

export function useColorScheme() {
  const { colorScheme } = useToggleColorScheme();
  const isDark = colorScheme === "dark";
  const isLight = colorScheme === "light";

  return {
    isDark,
    isLight,
  };
}
